<template lang="html">
  <div class="stars" :class="theClass">
    <template v-if="stars">
      <template v-if="mode == 'number'">
        <v-image
          class="vibbra-icon-image"
          :src="'static/favicons/icon.svg'"
          title="Resultado da avaliação da Vibbra"
        />
        <v-text tag="span">{{ stars }}</v-text>
      </template>
      <template v-else-if="mode == 'full'">
        <v-icon name="star" />
        <v-icon name="star" />
        <v-icon name="star" />
        <v-icon name="star" />
        <v-icon name="star" />
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    stars: {
      default: 0,
      type: Number,
    },
    mode: {
      default: 'number',
      type: String,
    },
  },
  computed: {
    theClass() {
      return 'star-mode-' + this.mode + ' star-' + this.stars;
    },
  },
};
</script>

<style lang="scss">
.stars {
  font-size: 1em;
  display: flex !important;
  align-items: center;
  .text {
    color: gray;
    line-height: 1em;
    margin-top: 2px;
    font-weight: 300;
  }
  .icon {
    color: #feba4d;
    font-size: size(4);
  }
  &.star-mode-number {
    &.star-4 .icon {
      opacity: 0.9;
    }
    &.star-3 .icon {
      opacity: 0.8;
    }
    &.star-2 .icon {
      opacity: 0.7;
    }
    &.star-1 .icon {
      opacity: 0.6;
    }
  }
  &.star-mode-full {
    &.star-4 {
      .icon + .icon + .icon + .icon + .icon {
        color: gray(300);
      }
    }
    &.star-3 {
      .icon + .icon + .icon + .icon {
        color: gray(300);
      }
    }
    &.star-2 {
      .icon + .icon + .icon {
        color: gray(300);
      }
    }
    &.star-1 {
      .icon + .icon {
        color: gray(300);
      }
    }
    &.star-0 {
      .icon {
        color: gray(300);
      }
    }
  }
}
.vibbra-icon-image {
  width: 35px;
  border-radius: 50%;
  margin-bottom: 0.6em;
  mouse: pointer;
}
</style>



// WEBPACK FOOTER //
// src/parts/components/stars.vue